import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";

class ModalMarket extends Component {

    constructor(props) {
        super(props);
        this.state = {
            temp_market: ""
        };
    };

    componentWillMount() {
        this.setState({temp_market: this.props.market});
    }

    _close(){
        this.props.setMarket(false);
    }

    _set(){
        this.props.setMarket(this.state.temp_market);
    }

    _renderText(item) {
        return langRegister.get("modal-market", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          <img onClick={() => this._close()}
                               className={Styles.overlayCloseButton}
                               src={require("../../assets/images/close_icon.svg")}/>
                          <div>
                              <div className={Styles.overlayModalTitle}>
                                  {this._renderText("item_1")}
                              </div>
                              <div className={Styles.overlayModalText}>
                                  <span className={Styles.overlayModalTextBold}>{this._renderText("item_4")}</span> {this._renderText("item_5")}
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => this._close()}
                                   className={Styles.overlayModalButtonsItemButton}>
                                  {this._renderText("item_2")}
                              </div>
                          </div>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {this._renderText("item_3")}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalMarket;


// WEBPACK FOOTER //
// ./src/components/modal-market/component.js